import React from 'react';
import { Button } from 'antd';
import { EyeOutlined, DeleteOutlined, PrinterOutlined } from '@ant-design/icons';
import PaymentReceipt from './PaymentReceipt';

const PaymentsTable = ({ currentPayments, handleViewDetails, handleDeletePayment }) => (
  <div className="overflow-x-auto">
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            رقم الإيصال
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            العميل
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
            المبلغ
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell">
            التاريخ
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">
            النوع
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider hidden sm:table-cell">
            الحالة
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">
            التفاصيل
          </th>
          <th className="px-2 md:px-6 py-2 md:py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
            الإجراءات
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-200">
        {currentPayments && currentPayments.length > 0 ? (
          currentPayments.map(payment => (
            <tr key={payment.id} className="hover:bg-gray-50">
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-900">{payment.id}</td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-900 max-w-[120px] truncate">
                {payment.client_name || 'غير محدد'}
                <div className="text-xs text-gray-500 md:hidden">
                  {payment.case_number ? `قضية: ${payment.case_number}` : ''}
                </div>
              </td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-900 font-medium">{payment.amount} د.ع</td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-500 hidden sm:table-cell">
                {new Date(payment.date).toLocaleDateString('ar-EG')}
              </td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-500 hidden md:table-cell">
                {payment.type === 'case' ? 'قضية' : payment.type === 'consultation' ? 'استشارة' : 'أخرى'}
              </td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap hidden sm:table-cell">
                <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full
                  ${payment.status === 'completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                  {payment.status === 'completed' ? 'مكتمل' : 'معلق'}
                </span>
              </td>
              <td className="px-2 md:px-6 py-2 md:py-4 text-sm text-gray-500 hidden md:table-cell max-w-[120px] truncate">
                {payment.description
                  ? (payment.description.length > 30
                      ? `${payment.description.substring(0, 30)}...`
                      : payment.description)
                  : 'لا توجد تفاصيل'}
              </td>
              <td className="px-2 md:px-6 py-2 md:py-4 whitespace-nowrap text-sm text-gray-500 text-center">
                <div className="flex justify-center gap-1 md:gap-2">
                  <button
                    onClick={() => handleViewDetails(payment)}
                    className="text-blue-600 hover:text-blue-900 p-1"
                    title="عرض التفاصيل"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </button>
                  <PaymentReceipt
                    payment={payment}
                    showLabel={false}
                    className="text-green-600 hover:text-green-700 flex items-center justify-center p-1"
                  />
                  <button
                    onClick={() => handleDeletePayment(payment.id)}
                    className="text-red-600 hover:text-red-900 p-1"
                    title="حذف"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" className="px-2 py-4 text-center text-gray-500">
              لا توجد مدفوعات مطابقة لمعايير البحث
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default PaymentsTable;